<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="data"
      :rowKey="record => record.id"
      :scroll="{ x: 3000 }"
      bordered
    >
      <template slot="serial">{{ $t('business.label.serial') }}</template>
      <template slot="zoneName">{{ $t('business.label.zoneName') }}</template>
      <template slot="locationName">{{ $t('business.label.locationName') }}</template>
      <template slot="locationNo">{{ $t('business.label.locationNo') }}</template>
      <template slot="roadWay">{{ $t('business.label.roadWay') }}</template>
      <template slot="x">{{ $t('business.label.row') }}</template>
      <template slot="z">{{ $t('business.label.column') }}</template>
      <template slot="y">{{ $t('business.label.layer') }}</template>
      <template slot="depth">{{ $t('business.label.depth') }}</template>
      <template slot="locationType">{{ $t('business.label.locationType') }}</template>
      <template slot="storageType">{{ $t('business.label.storageType') }}</template>
      <template slot="rackType">{{ $t('business.label.rackType') }}</template>
      <template slot="capacity">{{ $t('business.label.capacity') }}</template>
      <template slot="storageState">{{ $t('business.label.storageState') }}</template>
      <template slot="locationStatus">{{ $t('business.label.locationStatus') }}</template>
      <template slot="saleClassification">{{ $t('business.label.saleClassification') }}</template>
      <template slot="pileupType">{{ $t('business.label.pileupType') }}</template>
      <template slot="region">{{ $t('business.label.region') }}</template>
      <template slot="length">{{ $t('business.label.length') }}</template>
      <template slot="width">{{ $t('business.label.width') }}</template>
      <template slot="height">{{ $t('business.label.height') }}</template>
      <template slot="occupiedCapacity">{{ $t('business.label.occupiedCapacity') }}</template>
      <template slot="transferline">{{ $t('business.label.transferLine') }}</template>
      <template slot="storerName">{{ $t('business.label.storerName') }}</template>
      <template slot="weight">{{ $t('business.label.weight') }}</template>
      <template slot="shortNo">{{ $t('business.label.shortNo') }}</template>
      <template slot="containerControl">{{ $t('business.label.containerControl') }}</template>
      <template slot="automatic">{{ $t('business.label.automatic') }}</template>
      <template slot="locking">{{ $t('business.label.locking') }}</template>
      <template slot="available">{{ $t('business.label.available') }}</template>

      <!--序号值-->
      <span slot="Serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>

      <!--货位类型的枚举转换-->
      <span slot="LocationType" slot-scope="text" >
        <span
          v-for="(value,key) in locationTypeData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 存放类型的枚举转换-->
      <span slot="StorageType" slot-scope="text" >
        <span
          v-for="(value,key) in storageTypeData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 货架类型的枚举转换-->
      <span slot="RackType" slot-scope="text" >
        <span
          v-for="(value,key) in rackTypeData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 存放状态的枚举转换-->
      <span slot="StorageState" slot-scope="text" >
        <span
          v-for="(value,key) in storageStateData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 货位状态的字典转换-->
      <span slot="LocationStatus" slot-scope="text" >
        <span
          v-for="(value,key) in locationStatusData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 销售分类的枚举转换-->
      <span slot="SaleClassification" slot-scope="text" >
        <span
          v-for="(value,key) in saleClassificationData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- 码放类型的枚举转换-->
      <span slot="PileupType" slot-scope="text" >
        <span
          v-for="(value,key) in pileupTypeData"
          :key="key">
          <span v-if="text===value.ordinal">{{ value.name }}</span>
        </span>
      </span>
      <!-- checkBox渲染-->
      <span slot="ContainerControl" slot-scope="text">
        <a-checkbox :checked="text" disabled />
      </span>
      <!-- checkBox渲染-->
      <span slot="Automatic" slot-scope="text">
        <a-checkbox :checked="text" disabled />
      </span>
      <!-- checkBox渲染-->
      <span slot="Locking" slot-scope="text">
        <a-checkbox :checked="text" disabled />
      </span>
      <!-- checkBox渲染-->
      <span slot="Available" slot-scope="text">
        <a-checkbox :checked="text" disabled />
      </span>

      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-input
          v-ant-ref="c => searchInput = c"
          :value="selectedKeys[0]"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          style="width: 188px; margin-bottom: 8px; display: block;"
        />
        <a-button
          type="primary"
          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px">{{ $t('button.query') }}</a-button>
        <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">{{ $t('button.reset') }}</a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"/>
      <template slot="search" slot-scope="text, record, index, column">
        <span v-if="searchText && searchedColumn === column.dataIndex">
          <template
            v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
          >
            <mark
              v-if="fragment.toLowerCase() === searchText.toLowerCase()"
              :key="i"
              class="highlight"
            >{{ fragment }}</mark
            >
            <template
              v-else
            >{{ fragment }}</template
            >
          </template>
        </span>
        <template
          v-else
        >{{ text }}</template
        >
      </template>

    </a-table>
  </div>
</template>

<script>
    import {findEnum} from '@/api/Api';
  import { exportToExcel } from '@/components/Excel/export/exportFunction'
  import { excelName, filterVal, headerData } from '@/api/dto_js/import/locationBaseData'
  import { nameToOrdinal, ordinalToName, transformData } from '@/api/dto_js/import/transform'
    import {checkFieldType} from '@/utils/field-check'

  const columns = [
    {
      scopedSlots: { customRender: 'Serial',title:'serial' }
    },
    {
      dataIndex: 'zone.name',
      key:'zone.name',
      scopedSlots: { title:'zoneName' }
    },
    {
      dataIndex: 'name',
      key:'name',
      scopedSlots: {  title: 'locationName' },
    },
    {
      dataIndex: 'no',
      scopedSlots: {
        customRender: 'search',
        title:'locationNo',
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon' },
      onFilter: (value, record) => record.no.toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          }, 0);
        }
      },
    },
    {
      dataIndex: 'roadway',
      scopedSlots: { title:'roadWay' }
    },
    {
      // title: '排',
      dataIndex: 'x',
      scopedSlots: { title:'x' }
    },
    {
      // title: '列',
      dataIndex: 'z',
      scopedSlots: { title:'z' }
    },
    {
      // title: '层',
      dataIndex: 'y',
      scopedSlots: { title:'y' }
    },
    {
      // title: '深度',
      dataIndex: 'depth',
      scopedSlots: { title:'depth' }
    },
    {
      dataIndex: 'locationType',
      scopedSlots: { customRender: 'LocationType',title:'locationType' }
    },
    // 多的
    {
      dataIndex: 'storageType',
      scopedSlots: { customRender: 'StorageType',title:'storageType' }
    },
    {
      dataIndex: 'rackType',
      scopedSlots: { customRender: 'RackType',title:'rackType' }
    },
    {
      dataIndex: 'capacity',
      scopedSlots: { title:'capacity' }
    },
    {
      dataIndex: 'storageState',
      scopedSlots: { customRender: 'StorageState',title:'storageState' }
    },
    {
      dataIndex: 'locationStatus',
      scopedSlots: { customRender: 'LocationStatus',title:'locationStatus' }
    },
    {
      dataIndex: 'saleClassification',
      scopedSlots: { customRender: 'SaleClassification',title:'saleClassification' }
    },
    {
      dataIndex: 'pileupType',
      scopedSlots: { customRender: 'PileupType',title:'pileupType' }
    },
    {
      dataIndex: 'region',
      scopedSlots: { title:'region' }
    },
    {
      dataIndex: 'length',
      scopedSlots: { title:'length' }
    },
    {
      dataIndex: 'width',
      scopedSlots: { title:'width' }
    },
    {
      dataIndex: 'height',
      scopedSlots: { title:'height' }
    },
    {
      dataIndex: 'occupiedCapacity',
      scopedSlots: { title:'occupiedCapacity' }
    },
    {
      dataIndex: 'transferline',
      scopedSlots: { title:'transferline' }
    },
    {
      dataIndex: 'storer.name',
      scopedSlots: { title:'storerName' }
    },
    {
      dataIndex: 'weight',
      scopedSlots: { title:'weight' }
    },
    {
      dataIndex: 'shortNo',
      scopedSlots: { title:'shortNo' }
    },
    {
      dataIndex: 'containerControl',
      scopedSlots: { customRender: 'ContainerControl',title:'containerControl' }
    },
    {
      dataIndex: 'automatic',
      scopedSlots: { customRender: 'Automatic',title:'automatic' }
    },
    {
      dataIndex: 'locking',
      scopedSlots: { customRender: 'Locking', title: 'locking' }
    }
  ];


  export default {
    name: 'LocationBaseData',
    data() {
      return {
        data:[],
        columns,
        loading: false,
        locationTypes: [],
        storageTypes: [],
        rackTypes: [],
        storageStateData:[],
        saleClassifications: [],
        pileupTypes: [],
        locationStatus: [],
        searchText: '',
        searchInput: null,
        searchedColumn: '',
      };
    },
    mounted(){
      this.fetchEnum('LocationType').then(res => {
        this.locationTypeData = res
      })
      this.fetchEnum('StorageType').then(res => {
        this.storageTypeData = res
      })
      this.fetchEnum('RackType').then(res => {
        this.rackTypeData = res
      })
      this.fetchEnum('StorageState').then(res => {
        this.storageStateData = res
      })
      this.fetchEnum('SaleClassification').then(res => {
        this.saleClassificationData = res
      })
      this.fetchEnum('PileupType').then(res => {
        this.pileupTypeData = res
      })
      this.fetchEnum('LocationStatus').then(res => {
        this.locationStatusData = res
      })
    },
    methods: {
      fetchEnum (value){
          return findEnum(value)
      },
      getData(data){
        this.data=data
      },
      handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset(clearFilters) {
        clearFilters();
        this.searchText = ''
      },
      exportData(){

        const excelData = JSON.parse(JSON.stringify(this.data))
        for (let x=0;x<excelData.length;x++){
          if(excelData[x].zone){
            excelData[x].zone=excelData[x].zone.name
          }
          if(excelData[x].storer){
            excelData[x].storer=excelData[x].storer.name
          }
          excelData[x] = ordinalToName(excelData[x], 'locationType', this.locationTypes)
          excelData[x] = ordinalToName(excelData[x], 'storageType', this.storageTypes)
          excelData[x] = ordinalToName(excelData[x], 'rackType', this.rackTypes)
          excelData[x]=ordinalToName(excelData[x],'storageState',this.storageStateData)
          excelData[x] = ordinalToName(excelData[x], 'locationStatus', this.locationStatus)
          excelData[x] = ordinalToName(excelData[x], 'saleClassification', this.saleClassifications)
          excelData[x] = ordinalToName(excelData[x], 'pileupType', this.pileupTypes)
        }
        exportToExcel(headerData, filterVal, excelData, excelName)
      },
      transformData(data){
        // zone storer 尚未转换
        const list=transformData(headerData,filterVal,data)
        // this.$message.info(JSON.stringify(list))
        for(let i=0;i<list.length;i++){
          if(list[i].zone){
            list[i].zone={name:list[i].zone}
          }
          if(list[i].storer){
            list[i].storer={name:list[i].storer}
          }
          list[i] = nameToOrdinal(list[i], 'locationType', this.locationTypes)
          list[i] = nameToOrdinal(list[i], 'storageType', this.storageTypes)
          list[i] = nameToOrdinal(list[i], 'rackType', this.rackTypes)
          list[i] = nameToOrdinal(list[i], 'storageState', this.storageStateData)
          list[i] = nameToOrdinal(list[i], 'locationStatus', this.locationStatus)
          list[i] = nameToOrdinal(list[i], 'saleClassification', this.saleClassifications)
          list[i] = nameToOrdinal(list[i], 'pileupType', this.pileupTypes)
        }
        this.data = list
      },
      save() {

        const arrLocation = []

        this.data.forEach(item => {
          item['id'] = null
          item['version'] = 0

          const map = new Map()
          map.set('type', 'locationPersister')
          map.set('dataId', item.no)
          map.set('content', item)
          const returnValue = checkFieldType(map)
          arrLocation.push(returnValue)
        })
        // this.$message.info(JSON.stringify(this.data))
        this.$emit('sendSave', arrLocation)
      },
      // save(){
      //   this.data.forEach(item=>{
      //     item['id']=null
      //     item['version']=0
      //   })
      //   // this.$message.info(JSON.stringify(this.data))
      //   this.$emit('sendSave',this.data)
      // },
      clear() {
        this.data = []
      }
    },
  };
</script>